import { useEffect } from "react";
import { api, API } from "../lib/api";

function setMeta(selector, attr, content) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    const [kind, name] = attr;
    tag.setAttribute(kind, name);
    document.head.appendChild(tag);
  }
  tag.content = content;
}

const abs = (u) => (u && u.startsWith("/") ? `${API}${u}` : u);

export default function SiteMeta() {
  useEffect(() => {
    api.get("/content").then((r) => {
      const site = r.data.site || {};
      if (site.site_title) document.title = site.site_title;
      const desc = site.share_description || site.meta_description;
      if (desc) {
        setMeta('meta[name="description"]', ["name", "description"], desc);
        setMeta('meta[property="og:description"]', ["property", "og:description"], desc);
      }
      if (site.site_title) setMeta('meta[property="og:title"]', ["property", "og:title"], site.site_title);
      const img = abs(site.share_image_url) || abs(site.favicon_url);
      if (img) setMeta('meta[property="og:image"]', ["property", "og:image"], img);
      if (site.favicon_url) {
        let link = document.querySelector('link[rel="icon"]');
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = abs(site.favicon_url);
      }
    }).catch(() => {});
  }, []);
  return null;
}
